import assets from "@/utils/assets";

const icon = (name) => assets.image(name, "icon");

export default {
  data: icon("data.svg"),
  "no-info": icon("no-info.png"),
  "member-search": icon("member-search@3x.png"),
};
